// extracted by mini-css-extract-plugin
export default {"animatedBackground":"styles_animatedBackground__1pDvi","placeHolderShimmer":"styles_placeHolderShimmer__qVppt"};